export default __webpack_public_path__ + "static/small-0413e4fcc116930886b6745e146d97e2.jpg";